import { DateUtility } from 'packages/utilities/DateUtility';
import moment from 'moment';
var NotificationsAggregate = /** @class */ (function () {
    function NotificationsAggregate(jobId, event) {
        this.jobId = jobId;
        this.event = event;
        this.notifications = [];
    }
    Object.defineProperty(NotificationsAggregate.prototype, "jobName", {
        get: function () {
            return this.notifications.length > 0 ?
                this.notifications[0].data.job.name :
                null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(NotificationsAggregate.prototype, "eventTime", {
        get: function () {
            return new DateUtility(this.notifications[0].createdAt);
        },
        enumerable: false,
        configurable: true
    });
    NotificationsAggregate.prototype.eventDay = function (i18n) {
        return this.eventTime.moment.calendar(null, {
            sameDay: "[" + i18n.t('datetime.today') + "]",
            lastDay: "[" + i18n.t('datetime.yesterday') + "]",
            lastWeek: this.eventTime.format(),
            sameElse: this.eventTime.format(),
        });
    };
    Object.defineProperty(NotificationsAggregate.prototype, "unreadCount", {
        get: function () {
            return this.notifications.filter(function (notification) { return !notification.read; })
                .length;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(NotificationsAggregate.prototype, "fromStage", {
        get: function () {
            if (!['talent_moved', 'talents_moved'].includes(this.event)) {
                return null;
            }
            return this.notifications[0].data.from;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(NotificationsAggregate.prototype, "toStage", {
        get: function () {
            if (!['talent_moved', 'talents_moved'].includes(this.event)) {
                return null;
            }
            return this.notifications[0].data.to;
        },
        enumerable: false,
        configurable: true
    });
    return NotificationsAggregate;
}());
export { NotificationsAggregate };
var NotificationsAggregator = /** @class */ (function () {
    function NotificationsAggregator() {
    }
    NotificationsAggregator.prototype.byJobAndEvent = function (items) {
        var aggregatedList = [];
        var aggregate;
        items.forEach(function (item) {
            var condition = !aggregate
                || item.data.event !== aggregate.event
                || item.data.jobId !== aggregate.jobId;
            if (item.event === 'talent_moved') {
                condition = condition
                    || aggregate.toStage !== item.data.to
                    || aggregate.fromStage !== item.data.from;
            }
            if (item.event === 'talents_moved') {
                condition = true;
            }
            if (condition) {
                aggregate = new NotificationsAggregate(item.data.jobId, item.data.event);
                aggregatedList.push(aggregate);
            }
            if (aggregate.notifications.length) {
                aggregate.notifications = aggregate.notifications.filter(function (notification) {
                    return !(notification.data.talent && item.data.talent) ||
                        notification.data.talent.id !== item.data.talent.id;
                });
            }
            aggregate.notifications.push(item);
        });
        return aggregatedList;
    };
    NotificationsAggregator.prototype.byDay = function (items) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        var days = {};
        for (var _i = 0, items_1 = items; _i < items_1.length; _i++) {
            var item = items_1[_i];
            var day = moment(item.createdAt).format('YYYY-MM-DD');
            days[day] = (days[day] || []).concat([item]);
        }
        return Object.keys(days)
            .sort(function (a, b) {
            var timeA = moment(a);
            var timeB = moment(b);
            // latest first
            if (timeA.isAfter(timeB)) {
                return -1;
            }
            if (timeA.isBefore(timeB)) {
                return 1;
            }
            return 0;
        })
            .map(function (key) {
            var aggregate = new NotificationsAggregate();
            aggregate.notifications = days[key];
            return aggregate;
        });
    };
    return NotificationsAggregator;
}());
export { NotificationsAggregator };
